import styled from 'styled-components';

import { ListItem } from 'components/uikit/Form/ListItem/ListItem';
import { Icon } from 'components/uikit/Icon/Icon';

import { DEFAULT_THEME } from './Searcher.constants';

const THEMES = {
  1: {
    colorBkgDropdown: 'var(--color-white)',
    colorBkgItemSelected: 'var(--color-grey-1)',
    colorBkgItemHover: 'var(--color-grey-1)',
  },
  2: {
    colorBkgDropdown: 'var(--color-white)',
    colorBkgItemSelected: 'var(--color-grey-1)',
    colorBkgItemHover: 'var(--color-grey-1)',
  },
};

const getThemeVariable = (variable) => {
  return ({ theme = DEFAULT_THEME }) => {
    return THEMES[theme][variable];
  };
};

export const DropDownContainer = styled.div`
  --color-bkg-dropdown: ${getThemeVariable('colorBkgDropdown')};
  --color-bkg-item-selected: ${getThemeVariable('colorBkgItemSelected')};
  --color-bkg-item-hover: ${getThemeVariable('colorBkgItemHover')};

  background: var(--color-bkg-dropdown);
  border-radius: 12px;
  box-shadow: 0 4px 32px var(--color-grey-3);
  padding: 4px;
  max-height: 378px;
  overflow-y: auto;
  z-index: 9999999999;
`;

export const ListItemStyled = styled(ListItem)`
  cursor: pointer;
  border-radius: 12px;
  padding: 10px 12px;

  background-color: ${({ selected }) =>
    selected ? 'var(--color-bkg-item-selected)' : 'transparent'};

  &:hover {
    background: var(--color-bkg-item-hover);
  }
`;

export const CheckIcon = styled(Icon)`
  --color: var(--color-black);
`;

export const EmptyIcon = styled.div`
  width: 24px;
`;
